import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { obtenerSolicitudesWithStatus, obetenerSolicitud, Contadorfc_01PorLogin } from '../../../redux/SolicitudesDucks'
import { DataGrid } from '@mui/x-data-grid';
import { withRouter } from 'react-router-dom'
import { Paper } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { obtenerFC_01SolicitudDetalle, resetDataFC_01, eliminarFC_01SolicitudBD, setModoBorrador, obtenerFC_01Map, setModoCorreccion, obtenerFC_01SolicitudDetalleConFiles } from '../../../redux/DucksBeneficiario/FC_01Ducks'
import { actualizarModoBorradorFC_34, eliminarFC_34SolicitudBD, obtenerFC_34SolicitudDetalle, resetDataFC_34, setModoCorrecionFC_34, obtenerFC_34Map } from '../../../redux/DucksBeneficiario/FC_34Ducks';
import { actualizarModoBorradorFC_06, actualizarModoCorrecionFC_06, obtenerFC_06Map, eliminarFC_06SolicitudBD, obtenerFC_06SolicitudDetalle, resetDataFC_06 } from '../../../redux/DucksBeneficiario/FC_06Ducks'
import { actualizarModoBorradorFC_30, actualizarModoCorrecionFC_30, obtenerFC_30Map, eliminarFC_30SolicitudBD, obtenerFC_30SolicitudDetalle, resetDataFC_30 } from '../../../redux/DucksBeneficiario/FC_30Ducks';
import { actualizarModoBorradorFC_31, actualizarModoCorrecionFC_31, obtenerFC_31Map, eliminarFC_31SolicitudBD, obtenerFC_31SolicitudDetalle, resetDataFC_31 } from '../../../redux/DucksBeneficiario/FC_31Ducks';
import { actualizarModoBorradorFC_40, actualizarModoCorrecionFC_40, obtenerFC_40Map, eliminarFC_40SolicitudBD, obtenerFC_40SolicitudDetalle, resetDataFC_40 } from '../../../redux/DucksBeneficiario/FC_40Ducks';
import { actualizarModoBorradorFC_41, actualizarModoCorrecionFC_41, obtenerFC_41Map, eliminarFC_41SolicitudBD, obtenerFC_41SolicitudDetalle, resetDataFC_41 } from '../../../redux/DucksBeneficiario/FC_41Ducks';
import { actualizarModoBorradorFC_35, eliminarFC_35SolicitudBD, resetDataFC_35, setModoCorrecionFC_35, obtenerFC_35Map, obtenerFC_35SolicitudDetalleParaDocumentacion } from '../../../redux/DucksBeneficiario/FC_35Ducks'
import { actualizarModoBorradorFC_05, eliminarFC_05SolicitudBD, obtenerFC_05SolicitudDetalle, resetDataFC_05, setModoCorrecionFC_05, obtenerFC_05Map, obtenerFC_05SolicitudDetalleParaDocumentacion } from '../../../redux/DucksBeneficiario/FC_05Ducks'
import { actualizarModoBorradorFC_08, actualizarModoCorrecionFC_08, obtenerFC_08Map, eliminarFC_08SolicitudBD, obtenerFC_08SolicitudDetalle, resetDataFC_08 } from '../../../redux/DucksBeneficiario/FC_08Ducks'
import { actualizarModoBorradorFC_09, actualizarModoCorrecionFC_09, obtenerFC_09Map, eliminarFC_09SolicitudBD, obtenerFC_09SolicitudDetalle, resetDataFC_09, obtenerFC_09SolicitudDetalleParaDocumentacion } from '../../../redux/DucksBeneficiario/FC_09Ducks';
import { actualizarModoBorradorFC_33, actualizarModoCorrecionFC_33, obtenerFC_33Map, eliminarFC_33SolicitudBD, obtenerFC_33SolicitudDetalle, resetDataFC_33 } from '../../../redux/DucksBeneficiario/FC_33Ducks';
import { actualizarModoBorradorFC_36, actualizarModoCorrecionFC_36, obtenerFC_36Map, eliminarFC_36SolicitudBD, obtenerFC_36SolicitudDetalle, resetDataFC_36 } from '../../../redux/DucksBeneficiario/FC_36Ducks';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import estilos from './mainComponents.module.css';
import Tooltip from '@mui/material/Tooltip';
import BotonDescargarSolicitudComponent from '../../App/BotonDescargarSolicitudComponent';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
// const headerSolicitudes = {
//     backgroundColor: '#c88b3e !important',
//     color: 'white',
// };
function SolicitudesMain(props) {

    const currentUser = useSelector(store => store.Usuario.data)
    const loginIn = localStorage.getItem('user')
    let idUsuario = 0
    if (currentUser) {
        idUsuario = currentUser.user[0].id
    }

    const tipoUsuario = useSelector(store => store.Usuario.tipoUsuario)

    const dispatch = useDispatch()
    const solicitudes = useSelector(store => store.Solicitudes.data)

    const solicitudesStatus = useSelector(store => store.Solicitudes.status)



    /******Modal */
    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const [parametros, setParametros] = React.useState()
    const handleOpenModal = (data) => {
        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setParametros(data.parametros)
        setOpenModal(true)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setParametros()
        setOpenModal(false)
    }

    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>{titleModal}</center>
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }} component="h2">
                            {bodyModal} <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-success' onClick={() => {
                                switch (accion) {
                                    case 'eliminarBorrador':
                                        eliminarSolicitud(parametros)
                                        break;
                                }
                            }
                            }>CONTINUAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }

    React.useEffect(() => {
        if (solicitudesStatus === 0) {
            const solicitudes = dispatch(Contadorfc_01PorLogin({ idlogin: idUsuario }))
            props.history.push('/solicitudes')
            // dispatch(obtenerSolicitudesWithStatus({status:2,idLogin:idUsuario}))
        } else {
            dispatch(Contadorfc_01PorLogin({ idlogin: idUsuario }))
            dispatch(obtenerSolicitudesWithStatus({ status: solicitudesStatus, idLogin: idUsuario }))
            props.history.push('/solicitudes')
        }
    }, [])

    async function verDetalle(params) {
        await dispatch(obetenerSolicitud(params))
        props.history.push('/solicitud_detalle')
    }

    async function eliminarSolicitudModal(params) {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de eliminar un borrador, se borrará toda la información relacionada y
            este cambio no se podrá revertir.`,
            accion: 'eliminarBorrador',
            parametros: params
        })
    }

    async function eliminarSolicitud(params) {
        let solicitud = params.row
        let formato = params.row.formato
        switch (formato) {
            case 'FC_01':
                await dispatch(eliminarFC_01SolicitudBD(solicitud.solicitudId))
                await dispatch(resetDataFC_01())
                await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: idUsuario }))

                handleCloseModal()
                dispatch(Contadorfc_01PorLogin({ idlogin: idUsuario }))
                props.history.push('/fc_01')
                break;
            case 'FC_05':
                await dispatch(eliminarFC_05SolicitudBD(solicitud.solicitudId))
                await dispatch(resetDataFC_05())
                await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: idUsuario }))
                handleCloseModal()
                props.history.push('/solicitudes')
                break;
            case 'FC_06':
                await dispatch(eliminarFC_06SolicitudBD(solicitud.solicitudId))
                await dispatch(resetDataFC_06())
                await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: idUsuario }))
                handleCloseModal()
                props.history.push('/solicitudes')
                break;
            case 'FC_08':
                await dispatch(eliminarFC_08SolicitudBD(solicitud.solicitudId))
                await dispatch(resetDataFC_08())
                await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: idUsuario }))
                handleCloseModal()
                props.history.push('/solicitudes')
                break;
            case 'FC_09':
                await dispatch(eliminarFC_09SolicitudBD(solicitud.solicitudId))
                await dispatch(resetDataFC_09())
                await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: idUsuario }))
                handleCloseModal()
                props.history.push('/solicitudes')
                break;
            case 'FC_30':
                await dispatch(eliminarFC_30SolicitudBD(solicitud.solicitudId))
                await dispatch(resetDataFC_30())
                await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: idUsuario }))
                handleCloseModal()
                props.history.push('/solicitudes')
                break;
            case 'FC_31':
                await dispatch(eliminarFC_31SolicitudBD(solicitud.solicitudId))
                await dispatch(resetDataFC_31())
                await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: idUsuario }))
                handleCloseModal()
                props.history.push('/solicitudes')
                break;
            case 'FC_33':
                await dispatch(eliminarFC_33SolicitudBD(solicitud.solicitudId))
                await dispatch(resetDataFC_33())
                await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: idUsuario }))
                handleCloseModal()
                props.history.push('/solicitudes')
                break;
            case 'FC_34':
                await dispatch(eliminarFC_34SolicitudBD(solicitud.solicitudId))
                await dispatch(resetDataFC_34())
                await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: idUsuario }))
                handleCloseModal()
                props.history.push('/solicitudes')
                break;
            case 'FC_35':
                await dispatch(eliminarFC_35SolicitudBD(solicitud.solicitudId))
                await dispatch(resetDataFC_35())
                await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: idUsuario }))
                handleCloseModal()
                props.history.push('/solicitudes')
                break;
            case 'FC_36':
                await dispatch(eliminarFC_36SolicitudBD(solicitud.solicitudId))
                await dispatch(resetDataFC_36())
                await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: idUsuario }))
                handleCloseModal()
                props.history.push('/solicitudes')
                break;
            case 'FC_40':
                await dispatch(eliminarFC_40SolicitudBD(solicitud.solicitudId))
                await dispatch(resetDataFC_40())
                await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: idUsuario }))
                handleCloseModal()
                props.history.push('/solicitudes')
                break;
            case 'FC_41':
                await dispatch(eliminarFC_41SolicitudBD(solicitud.solicitudId))
                await dispatch(resetDataFC_41())
                await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: idUsuario }))
                handleCloseModal()
                props.history.push('/solicitudes')
                break;
            default:
                break;
        }
    }

    async function seguirEditandoButton(params) {
        let solicitudId = params.row.solicitudId
        let formato = params.row.formato
        switch (formato) {
            case 'FC_01':
                await dispatch(resetDataFC_01())
                await dispatch(setModoBorrador(true))
                await dispatch(obtenerFC_01SolicitudDetalle(solicitudId))
                props.history.push('/fc_01')
                break;
            case 'FC_05':
                await dispatch(resetDataFC_05())
                await dispatch(actualizarModoBorradorFC_05(true))
                await dispatch(obtenerFC_05SolicitudDetalle(solicitudId))
                props.history.push('/fc_05')
                break;
            case 'FC_06':
                await dispatch(resetDataFC_06())
                await dispatch(actualizarModoBorradorFC_06(true))
                await dispatch(obtenerFC_06SolicitudDetalle(solicitudId))
                props.history.push('/fc_06')
                break;
            case 'FC_08':
                await dispatch(resetDataFC_08())
                await dispatch(actualizarModoBorradorFC_08(true))
                await dispatch(obtenerFC_08SolicitudDetalle(solicitudId))
                props.history.push('/fc_08')
                break;
            case 'FC_09':
                await dispatch(resetDataFC_09())
                await dispatch(actualizarModoBorradorFC_09(true))
                await dispatch(obtenerFC_09SolicitudDetalle(solicitudId))
                props.history.push('/fc_09')
                break;
            case 'FC_30':
                await dispatch(resetDataFC_30())
                await dispatch(actualizarModoBorradorFC_30(true))
                await dispatch(obtenerFC_30SolicitudDetalle(solicitudId))
                props.history.push('/fc_30')
                break;
            case 'FC_31':
                await dispatch(resetDataFC_31())
                await dispatch(actualizarModoBorradorFC_31(true))
                await dispatch(obtenerFC_31SolicitudDetalle(solicitudId))
                props.history.push('/fc_31')
                break;
            case 'FC_33':
                await dispatch(resetDataFC_33())
                await dispatch(actualizarModoBorradorFC_33(true))
                await dispatch(obtenerFC_33SolicitudDetalle(solicitudId))
                props.history.push('/fc_33')
                break;
            case 'FC_34':
                await dispatch(resetDataFC_34())
                await dispatch(actualizarModoBorradorFC_34(true))
                await dispatch(obtenerFC_34SolicitudDetalle(solicitudId))
                props.history.push('/fc_34')
                break;
            case 'FC_35':
                await dispatch(resetDataFC_35())
                await dispatch(actualizarModoBorradorFC_35(true))
                await dispatch(obtenerFC_35SolicitudDetalleParaDocumentacion(solicitudId))
                props.history.push('/fc_35')
                break;
            case 'FC_36':
                await dispatch(resetDataFC_36())
                await dispatch(actualizarModoBorradorFC_36(true))
                await dispatch(obtenerFC_36SolicitudDetalle(solicitudId))
                props.history.push('/fc_36')
                break;
            case 'FC_40':
                await dispatch(resetDataFC_40())
                await dispatch(actualizarModoBorradorFC_40(true))
                await dispatch(obtenerFC_40SolicitudDetalle(solicitudId))
                props.history.push('/fc_40')
                break;
            case 'FC_41':
                await dispatch(resetDataFC_41())
                await dispatch(actualizarModoBorradorFC_41(true))
                await dispatch(obtenerFC_41SolicitudDetalle(solicitudId))
                props.history.push('/fc_41')
                break;
            default:
                break;
        }
    }

    async function corregirButton(params) {
        let solicitudId = params.row.solicitudId
        let formato = params.row.formato
        switch (formato) {
            case 'FC_01':
                await dispatch(resetDataFC_01())
                await dispatch(setModoCorreccion(true))
                await dispatch(obtenerFC_01Map(solicitudId))
                await dispatch(obtenerFC_01SolicitudDetalleConFiles(solicitudId))
                props.history.push('/fc_01')
                break;
            case 'FC_05':
                await dispatch(resetDataFC_05())
                await dispatch(setModoCorrecionFC_05(true))
                await dispatch(obtenerFC_05Map(solicitudId))
                await dispatch(obtenerFC_05SolicitudDetalle(solicitudId))
                props.history.push('/fc_05')
                break;
            case 'FC_06':
                await dispatch(resetDataFC_06())
                await dispatch(actualizarModoCorrecionFC_06(true))
                await dispatch(obtenerFC_06Map(solicitudId))
                await dispatch(obtenerFC_06SolicitudDetalle(solicitudId))
                props.history.push('/fc_06')
                break;
            case 'FC_08':
                await dispatch(resetDataFC_08())
                await dispatch(actualizarModoCorrecionFC_08(true))
                await dispatch(obtenerFC_08Map(solicitudId))
                await dispatch(obtenerFC_08SolicitudDetalle(solicitudId))
                props.history.push('/fc_08')
                break;
            case 'FC_09':
                await dispatch(resetDataFC_09())
                await dispatch(actualizarModoCorrecionFC_09(true))
                await dispatch(obtenerFC_09Map(solicitudId))
                await dispatch(obtenerFC_09SolicitudDetalle(solicitudId))
                props.history.push('/fc_09')
                break;
            case 'FC_30':
                await dispatch(resetDataFC_30())
                await dispatch(actualizarModoCorrecionFC_30(true))
                await dispatch(obtenerFC_30Map(solicitudId))
                await dispatch(obtenerFC_30SolicitudDetalle(solicitudId))
                props.history.push('/fc_30')
                break;
            case 'FC_31':
                await dispatch(resetDataFC_31())
                await dispatch(actualizarModoCorrecionFC_31(true))
                await dispatch(obtenerFC_31Map(solicitudId))
                await dispatch(obtenerFC_31SolicitudDetalle(solicitudId))
                props.history.push('/fc_31')
                break;
            case 'FC_33':
                await dispatch(resetDataFC_33())
                await dispatch(actualizarModoCorrecionFC_33(true))
                await dispatch(obtenerFC_33Map(solicitudId))
                await dispatch(obtenerFC_33SolicitudDetalle(solicitudId))
                props.history.push('/fc_33')
                break;
            case 'FC_34':
                await dispatch(resetDataFC_34())
                await dispatch(setModoCorrecionFC_34(true))
                await dispatch(obtenerFC_34Map(solicitudId))
                await dispatch(obtenerFC_34SolicitudDetalle(solicitudId))
                props.history.push('/fc_34')
                break;
            case 'FC_35':
                await dispatch(resetDataFC_35())
                await dispatch(setModoCorrecionFC_35(true))
                await dispatch(obtenerFC_35Map(solicitudId))
                await dispatch(obtenerFC_35SolicitudDetalleParaDocumentacion(solicitudId))
                props.history.push('/fc_35')
                break;
            case 'FC_36':
                await dispatch(resetDataFC_36())
                await dispatch(actualizarModoCorrecionFC_36(true))
                await dispatch(obtenerFC_36Map(solicitudId))
                await dispatch(obtenerFC_36SolicitudDetalle(solicitudId))
                props.history.push('/fc_36')
                break;
            case 'FC_40':
                await dispatch(resetDataFC_40())
                await dispatch(actualizarModoCorrecionFC_40(true))
                await dispatch(obtenerFC_40Map(solicitudId))
                await dispatch(obtenerFC_40SolicitudDetalle(solicitudId))
                props.history.push('/fc_40')
                break;
            case 'FC_41':
                await dispatch(resetDataFC_41())
                await dispatch(actualizarModoCorrecionFC_41(true))
                await dispatch(obtenerFC_41Map(solicitudId))
                await dispatch(obtenerFC_41SolicitudDetalle(solicitudId))
                props.history.push('/fc_41')
                break;
            default:
                break;
        }
    }
    async function CargarDocumentacion(params) {
        let solicitudId = params.row.solicitudId
        let formato = params.row.formato
        switch (formato) {
            case 'FC_01':
                await dispatch(resetDataFC_01())
                await dispatch(obtenerFC_01SolicitudDetalleConFiles(solicitudId))
                props.history.push('/DocumentacionFC_01Component')
                break;
            case 'FC_05':
                await dispatch(resetDataFC_05())
                await dispatch(obtenerFC_05SolicitudDetalleParaDocumentacion(solicitudId))
                props.history.push('/DocumentacionFC_05Component')
                break;
            case 'FC_06':
                await dispatch(resetDataFC_06())
                await dispatch(obtenerFC_06SolicitudDetalle(solicitudId))
                props.history.push('/DocumentacionFC_06Component')
                break;
            case 'FC_08':
                await dispatch(resetDataFC_08())
                await dispatch(obtenerFC_08SolicitudDetalle(solicitudId))
                props.history.push('/DocumentacionFC_08Component')
                break;
            case 'FC_09':
                await dispatch(resetDataFC_09())
                await dispatch(obtenerFC_09SolicitudDetalleParaDocumentacion(solicitudId))
                props.history.push('/DocumentacionFC_09Component')
                break;
            case 'FC_30':
                await dispatch(resetDataFC_30())
                await dispatch(obtenerFC_30SolicitudDetalle(solicitudId))
                props.history.push('/DocumentacionFC_30Component')
                break;
            case 'FC_31':
                await dispatch(resetDataFC_31())
                await dispatch(obtenerFC_31SolicitudDetalle(solicitudId))
                props.history.push('/DocumentacionFC_31Component')
                break;
            case 'FC_33':
                await dispatch(resetDataFC_33())
                await dispatch(obtenerFC_33SolicitudDetalle(solicitudId))
                props.history.push('/DocumentacionFC_33Component')
                break;
            case 'FC_34':
                await dispatch(resetDataFC_34())
                await dispatch(obtenerFC_34SolicitudDetalle(solicitudId))
                props.history.push('/fc_34')
                break;
            case 'FC_35':
                await dispatch(resetDataFC_35())
                await dispatch(obtenerFC_35SolicitudDetalleParaDocumentacion(solicitudId))
                props.history.push('/DocumentacionFC_35Component')
                break;
            case 'FC_36':
                await dispatch(resetDataFC_36())
                await dispatch(obtenerFC_36SolicitudDetalle(solicitudId))
                props.history.push('/DocumentacionFC_36Component')
                break;
            case 'FC_40':
                await dispatch(resetDataFC_40())
                await dispatch(obtenerFC_40SolicitudDetalle(solicitudId))
                props.history.push('/DocumentacionFC_40Component')
                break;
            case 'FC_41':
                await dispatch(resetDataFC_41())
                await dispatch(obtenerFC_41SolicitudDetalle(solicitudId))
                props.history.push('/DocumentacionFC_41Component')
                break;
            default:
                break;
        }
    }
    const nameTablaDocumentos = {
        FC_01: 'fc_01_documentos',
        name_FC_01: 'idfc01_solicitudregistro',
        FC_09: 'fc_09_documentos',
        name_FC_09: 'idfc09_solicitudcertificado',
        FC_33: 'fc_33_documentos',
        name_FC_33: 'idfc33_solicitudenvasadonaciona',
        FC_30: 'fc_30_documentos',
        name_FC_30: 'idfc30_notificaciontrasladodepr',
        FC_05: 'fc_05_documentos',
        name_FC_05: 'idfc05_solicitudusomarcaeimagen',
        FC_35: 'fc_35_documentos',
        name_FC_35: 'idfc35_notificacionserviciosvar',
        FC_06: 'fc_06_documentos',
        name_FC_06: 'idfc06_registromaguey',
        FC_08: 'fc_08_documentos',
        name_FC_08: 'idfc08_renvacioncertificado',
        FC_40: 'fc_40_documentos',
        name_FC_40: 'idfc40_solicitudadquisicionholo',
        FC_34: 'fc_34_documentos',
        name_FC_34: 'idfc34_notificacionsuspencion',
        FC_41: 'fc_41_documentos',
        name_FC_41: 'idfc41_solicitudparabebidasconm',
        FC_31: 'fc_31_documentos',
        name_FC_31: 'idfc31_solicitudseguimiento',
        FC_36: 'fc_36_documentos',
        name_FC_36: 'idfc36_solicitudactualizacion',
    }

    const columns = [

        { field: 'folio', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Folio de solicitud', flex:.5 },
        { field: 'fecha', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'fecha Solicitud', flex:.5 },
        { field: 'solicitud', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Solicitud', flex:1 },
        //{ field: 'formato',headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Formato', width: 160},
        { field: 'estatus', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Estatus', flex:.5 },
        {
            field: 'accion', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Acciones', flex:.7,
            renderCell: (params) => (
                params.row.idestatusdesolicitudes === 5 ?
                    (
                        <>
                            <button onClick={() => corregirButton(params)} className='btn btn-danger btn-sm'>Ver observaciones</button>
                        </>
                    ) :
                    params.row.accion === 7 || params.row.idestatusdesolicitudes === 7 ?
                        (
                            <>
                                <button onClick={() => CargarDocumentacion(params)} className='btn btn-danger btn-sm'>Cargar Documentación</button>
                            </>
                        ) :
                        params.row.idestatusdesolicitudes === 1 ?
                            (
                                <>
                                    <button onClick={() => seguirEditandoButton(params)} className='btn btn-warning btn-sm'>Seguir editando</button>
                                    <button onClick={() => eliminarSolicitudModal(params)} className='ms-2 btn btn-danger btn-sm'>Eliminar</button>
                                </>
                            ) :
                            solicitudesStatus === 4 ?
                                (
                                    <BotonDescargarSolicitudComponent nameTabla={nameTablaDocumentos[params.row.formato]} nameFK={nameTablaDocumentos['name_' + params.row.formato]} idSolicitud={params.row.solicitudId} user='Beneficiario'></BotonDescargarSolicitudComponent>
                                ) : ''

            )
        }
    ]

    const columnsBasic = [
        { field: 'folio', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Folio', width: 100 },
        { field: 'fecha', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'fecha Solicitud', width: 130 },
        { field: 'nombre', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Nombre o Razón Social', width: 200 },
        {
            field: 'actividad', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Actividad', width: 230,
            renderCell: (params) => (
                <Tooltip title={params.row.actividad} >
                    <span className="csutable-cell-trucate">{params.row.actividad}</span>
                </Tooltip>
            )
        },
        { field: 'estatus', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Estatus', width: 150 },
        {
            field: 'accion', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Acciones', width: 230,
            renderCell: (params) => (

                params.row.accion === 3 ?
                    (
                        <>
                            {/* <button onClick={() => verDetalle(params)} className='btn btn-secondary btn-sm'>Ver detalle</button> */}
                        </>
                    ) :
                    params.row.accion === 5 ?
                        (
                            <button onClick={() => corregirButton(params)} className='btn btn-danger btn-sm'>Ver observaciones</button>
                        ) :
                        params.row.accion === 7 ?
                            (
                                <>
                                    <button onClick={() => CargarDocumentacion(params)} className='btn btn-danger btn-sm'>Cargar Documentación</button>
                                </>
                            ) :
                            // solicitudesStatus === 5 ? 
                            // (
                            //     <>
                            //     <button onClick={() => corregirButton(params)} className='btn btn-danger btn-sm'>Ver observaciones</button>  
                            //     </>
                            // ):
                            // solicitudesStatus === 2 ? 
                            // (
                            //     <button onClick={() => verDetalle(params)} className='btn btn-secondary btn-sm'>Ver detalle</button>
                            // ):
                            solicitudesStatus === 1 || params.row.accion === 1 ?
                                (
                                    <>
                                        <button onClick={() => seguirEditandoButton(params)} className='btn btn-warning btn-sm'>Seguir editando</button>
                                        <button onClick={() => eliminarSolicitudModal(params)} className='ms-2 btn btn-danger btn-sm'>Eliminar</button>
                                    </>
                                ) : ''


            )
        }
    ]
    const rows = [];
    {
        solicitudes.fc_01_solicitudderegistro.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            rows.push({ id: uuidv4(), solicitudId: solicitud.idfc01_solicitudregistro, folio: solicitud.folio, fecha: fecha, solicitud: 'Solicitud de registro', formato: 'FC_01', estatus: solicitudes.nombreestatus, uri: 'FC_01/obtenerUnaSolicitudFC_01/' })
        })
        solicitudes.fc_05_solicitudusomarcaeimagen.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombreestatus = ''
            if (solicitud.idestatusdesolicitudes == 1) nombreestatus = 'Borrador'
            if (solicitud.idestatusdesolicitudes == 2) nombreestatus = 'Enviado'
            if (solicitud.idestatusdesolicitudes == 3) nombreestatus = 'Revisión'
            if (solicitud.idestatusdesolicitudes == 4) nombreestatus = 'Aceptado'
            if (solicitud.idestatusdesolicitudes == 5) nombreestatus = 'Denegado'
            if (solicitud.idestatusdesolicitudes == 6) nombreestatus = 'Corregidas'
            if (solicitud.idestatusdesolicitudes == 7) nombreestatus = 'Documentación pendiente'
            rows.push({
                id: uuidv4(), solicitudId: solicitud.idfc05_solicitudusomarcaeimagen, folio: solicitud.folio,
                fecha: fecha, idestatusdesolicitudes: solicitud.idestatusdesolicitudes,
                solicitud: 'Solicitud de uso marca e imagen COMERCAM', formato: 'FC_05',
                estatus: nombreestatus, uri: 'FC_05/obtenerFormatoFC05/'
            })
        })
        solicitudes.fc_06_registrodemaguey.map(solicitud => {
            let nombreestatus = ''
            if (solicitud.idestatusdesolicitudes == 1) nombreestatus = 'Borrador'
            if (solicitud.idestatusdesolicitudes == 2) nombreestatus = 'Enviado'
            if (solicitud.idestatusdesolicitudes == 3) nombreestatus = 'Revisión'
            if (solicitud.idestatusdesolicitudes == 4) nombreestatus = 'Aceptado'
            if (solicitud.idestatusdesolicitudes == 5) nombreestatus = 'Denegado'
            if (solicitud.idestatusdesolicitudes == 6) nombreestatus = 'Corregidas'
            if (solicitud.idestatusdesolicitudes == 7) nombreestatus = 'Documentación pendiente'
            rows.push({
                id: uuidv4(), solicitudId: solicitud.idfc06_registromaguey,
                solicitud: 'Solicitud de registro de maguey', formato: 'FC_06',
                idestatusdesolicitudes: solicitud.idestatusdesolicitudes,
                folio: solicitud.folio, fecha: solicitud?.fechasolicitud?.substring(0, 10),
                estatus: nombreestatus, uri: 'FC_06/obtenerFormatoFC06/'
            })
        })
        solicitudes.fc_08_solicitudrenvacioncertificados.map(solicitud => {
            let nombreestatus = ''
            if (solicitud.idestatusdesolicitudes == 1) nombreestatus = 'Borrador'
            if (solicitud.idestatusdesolicitudes == 2) nombreestatus = 'Enviado'
            if (solicitud.idestatusdesolicitudes == 3) nombreestatus = 'Revisión'
            if (solicitud.idestatusdesolicitudes == 4) nombreestatus = 'Aceptado'
            if (solicitud.idestatusdesolicitudes == 5) nombreestatus = 'Denegado'
            if (solicitud.idestatusdesolicitudes == 6) nombreestatus = 'Corregidas'
            if (solicitud.idestatusdesolicitudes == 7) nombreestatus = 'Documentación pendiente'
            rows.push({
                id: uuidv4(), solicitudId: solicitud.idfc08_renvacioncertificado,
                solicitud: 'Solicitud de renovación de certificado', formato: 'FC_08',
                estatus: nombreestatus, idestatusdesolicitudes: solicitud.idestatusdesolicitudes,
                folio: solicitud.folio, fecha: solicitud?.fechasolicitud?.substring(0, 10),
                uri: 'FC_08/obtenerFormatoFC08/'
            })
        })
        solicitudes.fc_09_solicitudemicioncertificadonomexportacionyentregahologram.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombreestatus = ''
            if (solicitud.idestatusdesolicitudes == 1) nombreestatus = 'Borrador'
            if (solicitud.idestatusdesolicitudes == 2) nombreestatus = 'Enviado'
            if (solicitud.idestatusdesolicitudes == 3) nombreestatus = 'Revisión'
            if (solicitud.idestatusdesolicitudes == 4) nombreestatus = 'Aceptado'
            if (solicitud.idestatusdesolicitudes == 5) nombreestatus = 'Denegado'
            if (solicitud.idestatusdesolicitudes == 6) nombreestatus = 'Corregidas'
            if (solicitud.idestatusdesolicitudes == 7) nombreestatus = 'Documentación pendiente'
            rows.push({
                id: uuidv4(), solicitudId: solicitud.idfc09_solicitudcertificado, folio: solicitud.folio,
                fecha: fecha, idestatusdesolicitudes: solicitud.idestatusdesolicitudes,
                solicitud: 'Solicitud de certificado NOM para exportación', formato: 'FC_09',
                estatus: nombreestatus, uri: 'FC_09/obtenerFormatoFC09/'
            })
        })
        solicitudes.fc_30_notificaciontrasladodeproducto.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombreestatus = ''
            if (solicitud.idestatusdesolicitudes == 1) nombreestatus = 'Borrador'
            if (solicitud.idestatusdesolicitudes == 2) nombreestatus = 'Enviado'
            if (solicitud.idestatusdesolicitudes == 3) nombreestatus = 'Revisión'
            if (solicitud.idestatusdesolicitudes == 4) nombreestatus = 'Aceptado'
            if (solicitud.idestatusdesolicitudes == 5) nombreestatus = 'Denegado'
            if (solicitud.idestatusdesolicitudes == 6) nombreestatus = 'Corregidas'
            if (solicitud.idestatusdesolicitudes == 7) nombreestatus = 'Documentación pendiente'
            rows.push({
                id: uuidv4(), solicitudId: solicitud.idfc30_notificaciontrasladodepr, folio: solicitud.folio,
                fecha: fecha, idestatusdesolicitudes: solicitud.idestatusdesolicitudes,
                solicitud: 'Solicitud traslado de producto', formato: 'FC_30', estatus: nombreestatus,
                uri: 'FC_30/obtenerFormatoFC30/'
            })
        })
        solicitudes.fc_31_solicitudseguimiento.map(solicitud => {
            let nombreestatus = ''
            if (solicitud.idestatusdesolicitudes == 1) nombreestatus = 'Borrador'
            if (solicitud.idestatusdesolicitudes == 2) nombreestatus = 'Enviado'
            if (solicitud.idestatusdesolicitudes == 3) nombreestatus = 'Revisión'
            if (solicitud.idestatusdesolicitudes == 4) nombreestatus = 'Aceptado'
            if (solicitud.idestatusdesolicitudes == 5) nombreestatus = 'Denegado'
            if (solicitud.idestatusdesolicitudes == 6) nombreestatus = 'Corregidas'
            if (solicitud.idestatusdesolicitudes == 7) nombreestatus = 'Documentación pendiente'
            rows.push({
                id: uuidv4(), solicitudId: solicitud.idfc31_solicitudseguimiento,
                folio: solicitud.folio, fecha: solicitud.fechasolicitud.substring(0, 10),
                idestatusdesolicitudes: solicitud.idestatusdesolicitudes,
                solicitud: 'Solicitud de seguimiento', formato: 'FC_31', estatus: nombreestatus,
                uri: 'FC_31/obtenerFormatoFC31/'
            })
        })
        solicitudes.fc_33_solicitudenvasadonacional.map(solicitud => {
            let nombreestatus = ''
            if (solicitud.idestatusdesolicitudes == 1) nombreestatus = 'Borrador'
            if (solicitud.idestatusdesolicitudes == 2) nombreestatus = 'Enviado'
            if (solicitud.idestatusdesolicitudes == 3) nombreestatus = 'Revisión'
            if (solicitud.idestatusdesolicitudes == 4) nombreestatus = 'Aceptado'
            if (solicitud.idestatusdesolicitudes == 5) nombreestatus = 'Denegado'
            if (solicitud.idestatusdesolicitudes == 6) nombreestatus = 'Corregidas'
            if (solicitud.idestatusdesolicitudes == 7) nombreestatus = 'Documentación pendiente'
            rows.push({
                id: uuidv4(), solicitudId: solicitud.idfc33_solicitudenvasadonaciona,
                folio: solicitud.folio, fecha: solicitud.fechasolicitud.substring(0, 10),
                idestatusdesolicitudes: solicitud.idestatusdesolicitudes,
                solicitud: 'Solicitud de envasado nacional', formato: 'FC_33',
                estatus: nombreestatus, uri: 'FC_33/obtenerFormatoFC33/'
            })
        })
        solicitudes.fc_34_notificacionsuspencionyreactivacion.map(solicitud => {
            let nombreestatus = ''
            if (solicitud.idestatusdesolicitudes == 1) nombreestatus = 'Borrador'
            if (solicitud.idestatusdesolicitudes == 2) nombreestatus = 'Enviado'
            if (solicitud.idestatusdesolicitudes == 3) nombreestatus = 'Revisión'
            if (solicitud.idestatusdesolicitudes == 4) nombreestatus = 'Aceptado'
            if (solicitud.idestatusdesolicitudes == 5) nombreestatus = 'Denegado'
            if (solicitud.idestatusdesolicitudes == 6) nombreestatus = 'Corregidas'
            if (solicitud.idestatusdesolicitudes == 7) nombreestatus = 'Documentación pendiente'
            rows.push({
                id: uuidv4(), solicitudId: solicitud.idfc34_notificacionsuspencion,
                folio: solicitud.folio, fecha: solicitud.fechasolicitud.substring(0, 10),
                idestatusdesolicitudes: solicitud.idestatusdesolicitudes,
                solicitud: 'Notificación suspensión y reactivación', formato: 'FC_34',
                estatus: nombreestatus, uri: 'FC_34/obtenerFormatoFC34/'
            })
        })
        solicitudes.fc_35_notificaciondeserviciosvarios.map(solicitud => {
            let nombreestatus = ''
            if (solicitud.idestatusdesolicitudes == 1) nombreestatus = 'Borrador'
            if (solicitud.idestatusdesolicitudes == 2) nombreestatus = 'Enviado'
            if (solicitud.idestatusdesolicitudes == 3) nombreestatus = 'Revisión'
            if (solicitud.idestatusdesolicitudes == 4) nombreestatus = 'Aceptado'
            if (solicitud.idestatusdesolicitudes == 5) nombreestatus = 'Denegado'
            if (solicitud.idestatusdesolicitudes == 6) nombreestatus = 'Corregidas'
            if (solicitud.idestatusdesolicitudes == 7) nombreestatus = 'Documentación pendiente'
            rows.push({
                id: uuidv4(), solicitudId: solicitud.idfc35_notificacionserviciosvar,
                solicitud: 'Solicitud de servicios varios', formato: 'FC_35',
                idestatusdesolicitudes: solicitud.idestatusdesolicitudes,
                folio: solicitud.folio, fecha: solicitud.fechasolicitud.substring(0, 10),
                estatus: nombreestatus, uri: 'FC_35/obtenerFormatoFC35/'
            })
        }
        )
        solicitudes.fc_36_solicituddeactualizacion.map(solicitud => {
            let nombreestatus = ''
            if (solicitud.idestatusdesolicitudes == 1) nombreestatus = 'Borrador'
            if (solicitud.idestatusdesolicitudes == 2) nombreestatus = 'Enviado'
            if (solicitud.idestatusdesolicitudes == 3) nombreestatus = 'Revisión'
            if (solicitud.idestatusdesolicitudes == 4) nombreestatus = 'Aceptado'
            if (solicitud.idestatusdesolicitudes == 5) nombreestatus = 'Denegado'
            if (solicitud.idestatusdesolicitudes == 6) nombreestatus = 'Corregidas'
            if (solicitud.idestatusdesolicitudes == 7) nombreestatus = 'Documentación pendiente'
            rows.push({
                id: uuidv4(), solicitudId: solicitud.idfc36_solicitudactualizacion,
                solicitud: 'Solicitud de actualizacion', formato: 'FC_36',
                idestatusdesolicitudes: solicitud.idestatusdesolicitudes,
                folio: solicitud.folio, fecha: solicitud.fechasolicitud.substring(0, 10),
                estatus: nombreestatus, uri: 'FC_36/obtenerUnaSolicitudFC_36/'
            })
        })
        solicitudes.fc_40_solicituddeadquisiciondehologramas.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombreestatus = ''
            if (solicitud.idestatusdesolicitudes == 1) nombreestatus = 'Borrador'
            if (solicitud.idestatusdesolicitudes == 2) nombreestatus = 'Enviado'
            if (solicitud.idestatusdesolicitudes == 3) nombreestatus = 'Revisión'
            if (solicitud.idestatusdesolicitudes == 4) nombreestatus = 'Aceptado'
            if (solicitud.idestatusdesolicitudes == 5) nombreestatus = 'Denegado'
            if (solicitud.idestatusdesolicitudes == 6) nombreestatus = 'Corregidas'
            if (solicitud.idestatusdesolicitudes == 7) nombreestatus = 'Documentación pendiente'
            rows.push({
                id: uuidv4(), solicitudId: solicitud.idfc40_solicitudadquisicionholo,
                folio: solicitud.folio, fecha: solicitud.fechasolicitud.substring(0, 10),
                idestatusdesolicitudes: solicitud.idestatusdesolicitudes,
                solicitud: 'Solicitud de compra de hologramas', formato: 'FC_40', estatus: nombreestatus,
                uri: 'FC_40/obtenerFormatoFC40/'
            })
        })
        solicitudes.fc_41_solicitudparabebidasconmezcal.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombreestatus = ''
            if (solicitud.idestatusdesolicitudes == 1) nombreestatus = 'Borrador'
            if (solicitud.idestatusdesolicitudes == 2) nombreestatus = 'Enviado'
            if (solicitud.idestatusdesolicitudes == 3) nombreestatus = 'Revisión'
            if (solicitud.idestatusdesolicitudes == 4) nombreestatus = 'Aceptado'
            if (solicitud.idestatusdesolicitudes == 5) nombreestatus = 'Denegado'
            if (solicitud.idestatusdesolicitudes == 6) nombreestatus = 'Corregidas'
            if (solicitud.idestatusdesolicitudes == 7) nombreestatus = 'Documentación pendiente'
            rows.push({
                id: uuidv4(), solicitudId: solicitud.idfc41_solicitudparabebidasconm,
                folio: solicitud.folio, fecha: fecha, idestatusdesolicitudes: solicitud.idestatusdesolicitudes,
                solicitud: 'Solicitud para productos con mezcal', formato: 'FC_41', estatus: nombreestatus,
                uri: 'FC_41/obtenerFormatoFC41/'
            })
        })
    }
    const rowsBasic = [];
    {
        solicitudes.fc_01_solicitudderegistro.map(solicitud => {
            let viverista = ''
            let envasador = ''
            let productormaguey = ''
            let productormezcal = ''
            let comercializadormezcal = ''
            let comercializadorbebidasconmezcal = ''
            let cadena = ''
            if (solicitud.viverista === true) cadena += 'Viverista'
            if (solicitud.viverista && (solicitud.envasador || solicitud.productormaguey || solicitud.productormezcal ||
                solicitud.comercializadormezcal || solicitud.comercializadorbebidasconmezcal)) cadena += ','

            if (solicitud.productormaguey === true) cadena += 'Productor maguey'
            if (solicitud.productormaguey && (solicitud.productormezcal || solicitud.envasador ||
                solicitud.comercializadormezcal || solicitud.comercializadorbebidasconmezcal)) cadena += ','

            if (solicitud.productormezcal === true) cadena += 'Productor mezcal'
            if (solicitud.productormezcal && (solicitud.envasador || solicitud.comercializadormezcal || solicitud.comercializadorbebidasconmezcal)) cadena += ','

            if (solicitud.envasador === true) cadena += 'Envasador'
            if (solicitud.envasador && (solicitud.comercializadormezcal || solicitud.comercializadorbebidasconmezcal)) cadena += ','

            if (solicitud.comercializadormezcal === true) cadena += 'Comercializador mezcal'
            if (solicitud.comercializadormezcal && solicitud.comercializadorbebidasconmezcal) cadena += ','

            if (solicitud.comercializadorbebidasconmezcal === true) cadena += 'Comercializador de bebidas con mezcal'

            let arregloCadena = cadena.split(',')
            let combinacionCadena = ''
            let contador = 1
            for (const i in arregloCadena) {
                if (arregloCadena.length === 1) {
                    combinacionCadena += arregloCadena[i]
                } else {
                    if (arregloCadena.length === (contador + 1)) {
                        combinacionCadena += arregloCadena[i] + ' y '
                        contador++
                    } else {

                        combinacionCadena += arregloCadena[i]
                        if (arregloCadena.length !== contador) {
                            combinacionCadena += ', '
                        }
                        contador++
                    }

                }

            }
            let estatus = ''
            { solicitud.idestatusdesolicitudes === 1 ? (estatus = 'Borrador') : '' }
            { solicitud.idestatusdesolicitudes === 2 ? (estatus = 'Enviado') : '' }
            { solicitud.idestatusdesolicitudes === 3 ? (estatus = 'En proceso') : '' }
            { solicitud.idestatusdesolicitudes === 4 ? (estatus = 'Aceptada') : '' }
            { solicitud.idestatusdesolicitudes === 5 ? (estatus = 'Con observaciones') : '' }
            { solicitud.idestatusdesolicitudes === 6 ? (estatus = 'Corregidas') : '' }
            { solicitud.idestatusdesolicitudes === 7 ? (estatus = 'Documentacion pendiente') : '' }
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            rowsBasic.push({
                id: uuidv4(), solicitudId: solicitud.idfc01_solicitudregistro, folio: solicitud.folio,
                fecha: fecha, nombre: solicitud.nombrerazonsocial,
                actividad: combinacionCadena,

                formato: 'FC_01', estatus: estatus, uri: 'FC_01/obtenerUnaSolicitudFC_01/', accion: solicitud.idestatusdesolicitudes
            })
        })
    }


    return (
        <div className='container2'>
            <div className='row'>
                <div className='col-12 mt-1 ms-3 text-center' >
                    <div style={{ height: 600, width: '95%', color: 'black' }}>
                        <DataGrid
                            rows={tipoUsuario === 1 ? (rowsBasic) : (rows)}
                            columns={tipoUsuario === 1 ? (columnsBasic) : (columns)}
                            pageSize={10}
                            //sortModel={[{ field: 'fecha', sort: 'desc' }]}
                            
                            
                            initialState={{ sorting: { sortModel: [{ field: 'fecha', sort: 'desc' }], }, }}

                            sx={{
                                boxShadow: 0,
                                color: 'black',
                                border: 0,
                                '& .MuiDataGrid-cell': {
                                    display: 'block',
                                    position: 'relative',
                                    textAlign: 'center',
                                },
                            }}
                        />
                    </div>
                </div>
            </div>
            {modalComponent()}
        </div>
    )
}

export default withRouter(SolicitudesMain)
